import React from 'react';
import { ContentSingularData } from '../../_data/ContentSingularData';
import './iGEMVideo.css';

/**
 * Shows an embedded video, compatible
 * with videos from the iGEM Video Universe.
 *
 * Last Modified
 * Diandre Sabale
 * October 11, 2022
 */
export const iGEMVideo: React.FC<ContentSingularData> = ({
	video_videoLink,
	video_videoWidth,
	video_videoHeight
}) => {
	if (!video_videoLink || !video_videoHeight || !video_videoWidth) {
		return <></>
	}

	return <div className="centered wi-content-wrapper">
		<iframe
        	className="igem-video-player-auto-height"
			height={video_videoHeight+"px"}
        	width={video_videoWidth+"px"}
        	src={video_videoLink}
        	frameBorder="0" allowFullScreen 
        	sandbox="allow-same-origin allow-scripts allow-popups">
        </iframe>
	</div>
}